if (!window.Eurus.loadedScript.includes('pagination.js')) {
  window.Eurus.loadedScript.push('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        busy: false,

        async loadData(url) {
          if (this.busy || !url) return;
          this.busy = true;
          this.loading = true;

          try {
            const res = await fetch(url, { method: 'GET' });
            const txt = await res.text();

            const parser = new DOMParser();
            const html = parser.parseFromString(txt, 'text/html');
            const srcGrid = html.getElementById('items-grid') || html.getElementById('blog-grid');
            if (!srcGrid) {
              this._renderButton(null);
              return;
            }

            const newItems = srcGrid.getElementsByClassName('grid-item');
            if (!newItems.length) {
              this._renderButton(null);
              return;
            }

            let destGrid = document.getElementById('items-grid');
            const blogGrid = document.getElementById('blog-grid');
            if (blogGrid) destGrid = blogGrid;
            if (!destGrid) {
              this._renderButton(null);
              return;
            }

            let chunk = '';
            for (let i = 0; i < newItems.length; i++) {
              chunk += newItems[i].innerHTML;
            }
            destGrid.insertAdjacentHTML('beforeend', chunk);

            this._renderButton(html);
          } catch (e) {
            console.error('Pagination fetch error:', e);
            this._renderButton(null);
          } finally {
            this.loading = false;
            this.busy = false;
          }
        },

        _renderButton(htmlDoc) {
          const destination = document.getElementById('btn-pagination-' + sectionId);

          if (!htmlDoc) {
            if (destination) destination.innerHTML = `
              <p class="mb-3">
                ${destination.querySelector('p')?.innerHTML || ''}
              </p>
            `;
            return;
          }

          const source = htmlDoc.getElementById('btn-pagination-' + sectionId);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
          }
        }
      }));
    });
  });
}